import { render, staticRenderFns } from "./Qlik.vue?vue&type=template&id=f81d964c&"
import script from "./Qlik.vue?vue&type=script&lang=js&"
export * from "./Qlik.vue?vue&type=script&lang=js&"
import style0 from "./Qlik.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports